module.exports = __webpack_public_path__ + "media/images/site-section/confirmation-background-41e462c0c720c03efcb650a33d9a099b.jpg";